import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface NotificationEvent {
  onesignalMessageId: string;
  missionId: string;
  eventType: string;
  actionId?: string | null;
  occurredAt?: string;
}

export interface InAppNotification {
  id: string;
  missionId: string;
  type: string;
  payloadJson?: string;
  createdAt: string;
}

export interface AdminNotificationEvent {
  id: string;
  eventType: string;
  title: string;
  body: string;
  contextType: string | null;
  contextId: string | null;
  contextUrl: string | null;
  originSponsorContextId?: string | null;
  originSponsorName?: string | null;
  read: boolean;
  reactionCount: number;
  createdAt: string;
}

export interface AdminNotificationPage {
  content: AdminNotificationEvent[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationClientService {
  private readonly base = `${environment.agent.url}/notifications`;

  constructor(private http: HttpClient) {}

  recordEvent(event: NotificationEvent): Observable<void> {
    return this.http.post<void>(`${this.base}/events`, event);
  }

  /**
   * Notificações pendentes do ambiente informado. A notificação nasce de uma
   * missão, então o servidor resolve o ambiente pela missão de origem — sem o
   * escopo, notificação de campanha comercial aparecia dentro do RSM Politics.
   */
  getPendingInApp(scope?: 'COMMERCIAL' | 'POLITICS'): Observable<InAppNotification[]> {
    const query = scope ? `?scope=${scope}` : '';
    return this.http.get<InAppNotification[]>(`${this.base}/in-app/pending${query}`);
  }

  markInAppRead(id: string): Observable<void> {
    return this.http.post<void>(`${this.base}/in-app/${id}/read`, {});
  }

  // ── Admin Notifications ──────────────────────────────────────────────────

  getAdminNotifications(params?: { page?: number; size?: number; read?: boolean }): Observable<AdminNotificationPage> {
    let url = `${environment.agent.url}/admin-notifications?page=${params?.page ?? 0}&size=${params?.size ?? 20}`;
    if (params?.read !== undefined) {
      url += `&read=${params.read}`;
    }
    return this.http.get<AdminNotificationPage>(url);
  }

  markAdminNotificationRead(id: string): Observable<void> {
    return this.http.post<void>(`${environment.agent.url}/admin-notifications/${id}/read`, {});
  }

  getAdminUnreadCount(): Observable<{ count: number }> {
    return this.http.get<{ count: number }>(`${environment.agent.url}/admin-notifications/unread-count`);
  }
}
